import 'rxjs/add/operator/map';
import 'rxjs/add/operator/startWith';
import 'rxjs/Rx';

import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../../../Common/Services/shared.service';
import { AppMessage } from './../../../Common/appMessage';
import { AppGlobals } from './../../../Common/Services/app.global';
import { Utility } from './../../../Common/Services/utility';
import { AdmManageDomainComponent } from './../../../Components/adm-manage-domain/adm-manage-domain.component';
import { AdmManageCountryService } from './../adm-manage-country.service';

@Component({
  selector: 'app-adm-update-country',
  templateUrl: './adm-update-country.component.html',
  styleUrls: ['./adm-update-country.component.css'],
  providers: [AdmManageCountryService]
})
export class AdmUpdateCountryComponent implements OnInit {
  isEditBtnDisable: boolean;
  isSaveBtnDisable: boolean;
  title: string;
  id: number; // Primary field
  role: string;
  formControl: any;
  form: FormGroup;
  unsuportableExamTypes: any = [
    {"examType": "RE", "name": "Remote"},
    {"examType": "PE", "name": "Preliminary"},
    {"examType": "XE", "name": "Experience"}
  ];

  constructor(public _utility: Utility, private _admManageCountryService: AdmManageCountryService,
    public _appGlobals: AppGlobals, private _activatedRoute: ActivatedRoute,
    private _sharedService: SharedService, private _appMessage: AppMessage) {

    this.form = new FormGroup({unsupportedExamTypes: new FormControl('')});
    this.formControl = this.form.controls;
  }

  ngOnInit() {
    this._appGlobals.routeWithID = false;
    this.role = this._utility.getUserRole();
    this._utility.clearTxnStatus(); // close confirm box for FORM changes
    this.loadFormData()
  }

  loadFormData() {
    let countryId: number = this._activatedRoute.snapshot.params['countryId'];
    this.isEditBtnDisable = false;
    this.id = countryId;
    this.title = 'Edit Country';
    this.isSaveBtnDisable = true;
    this._utility.disableEnableForm(this.form, true);

    this._utility.addLoaderCount();
    this._admManageCountryService.searchCountries("?id=" + countryId).subscribe((response) => {
      this._utility.onSuccessCallback(response, null, () => {
        let data = response.response.results[0];
        this.title = 'Edit Country: ' + data.name;
        if (data) this.form.patchValue(data);
      });
    }, error => this._utility.onErrorCallback(error));
  }

  editCountry() {
    this._utility.disableEnableForm(this.form, false);
    this.isSaveBtnDisable = false;
    this.isEditBtnDisable = true;
  }

  saveCountry() {
    if (this.form.invalid) return;

    this._utility.addLoaderCount();
    let countryData = Object.assign({id: this.id}, this.form.getRawValue());
    this._admManageCountryService.saveCountry(countryData)
      .subscribe(data => {
        let msg = this._appMessage.getItem['UMsg00097'];
        this._utility.onSuccessCallback(data, msg, () => {
          this.isSaveBtnDisable = true;
          this.isEditBtnDisable = false;
          this._utility.disableEnableForm(this.form, true);
        });
    }, error => this._utility.onErrorCallback(error));
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-country/adm-update-country/adm-update-country.component.ts